'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequest$002dPharmacy$002dState from "./app.api.-Drug-Request-Pharmacy-State.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42(evaluator$28) {
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$42__f_evaluator$8 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$$anon$42__f_evaluator$8 = evaluator$28;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$42() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$42 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$42 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$42.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_DrugRequestsAcceptedListItem$$anon$42__f_evaluator$8.apply__O();
  return ($j_app$002eapi$002e$002dDrug$002dRequest$002dPharmacy$002dState.$is_Lapp_api_DrugRequestPharmacyState(v) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$42 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$42, "app.api.DrugRequestsAcceptedListItem$$anon$42", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$42: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$42 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$42 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$42.js.map
